import { render, staticRenderFns } from "./SettingsLocalization.vue?vue&type=template&id=74c73c16&scoped=true&"
import script from "./SettingsLocalization.vue?vue&type=script&lang=js&"
export * from "./SettingsLocalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c73c16",
  null
  
)

export default component.exports